import songs from './songs.json';
import './Songs.css';

const Songs = () => (
  <div className="song-list">
    <div className="playlist-button-wrapper">
      <a
        className="playlist-button"
        href="https://open.spotify.com/playlist/1tk4cndUUzzfxS4RPRrZRo?si=5040848b84ac4c52&pt=c3b97a45ccb6e076d01d71fc694f2aac"
        target="_blank"
        rel="noopener noreferrer"
      >
        Listen here :)
      </a>
    </div>
    {songs.map((song, index) => (
      <div key={index} className="song-row">
        <div className="left">
          <img src={song.cover} alt={`${song.title} cover`} />
          <div>
            <h3>{song.title}</h3>
            <p>{song.artist}</p>
          </div>
        </div>
        <div className="right">
          <p>{song.description}</p>
        </div>
      </div>
    ))}
  </div>
);

export default Songs;
